// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2YJF0","signatureButtonsRight":"ModalSign_signatureButtonsRight__uL6P0"};